import React from 'react';

interface Show {
  id: number;
  month: string;
  day: string;
  venue: string;
  location: string;
  time: string;
  ticketUrl: string;
  venueUrl: string;
  placeholderImage: string;
  placeholderAlt: string;
}

function Shows() {
  // Array of show data
  const shows: Show[] = [
    /*
    {
      id: 1,
      month: 'AUG',
      day: '20',
      venue: 'Harper & Pennys',
      location: 'Lansdale, PA',
      time: '7:00 PM',
      ticketUrl: 'https://www.bandsintown.com/a/15564903-wormwagon?came_from=257&utm_medium=web&utm_source=home&utm_campaign=search_bar',
      venueUrl: 'https://www.harperandpennys.com/',
      placeholderImage: '/images/show-posters/roundguys.jpg',
      placeholderAlt: 'Round Guys Show Poster'
    },
    */
  ];

  return (
    <main className="page-content">
      <section className="page-hero">
        <h1>Live Shows</h1>
      </section>

      <section className="upcoming-shows">
        {shows.length === 0 ? (
          <div className="no-shows-message">
            <p>Meeetup soon!</p>
          </div>
        ) : (
          <div className="shows-list">
            {shows.map((show, index) => {
              const isEven = index % 2 === 0; // Even index = placeholder on left, Odd = placeholder on right
              
              return (
                <div key={show.id} className="show-row">
                  {/* Left placeholder - only show if even index */}
                  {isEven && (
                    <div className={`show-placeholder left-placeholder ${show.venue === 'Ottobar' ? 'ottobar-placeholder' : ''} ${show.venue === 'The Pocket' ? 'pocket-placeholder' : ''} ${show.venue === 'Irisgarden Bar' ? 'irisgarden-placeholder' : ''}`}>
                      <img src={show.placeholderImage} alt={show.placeholderAlt} className="placeholder-image" />
                    </div>
                  )}
                  
                  {/* Show card */}
                  <div className="show-card">
                    <div className="show-date">
                      <span className="month">{show.month}</span>
                      <span className="day">{show.day}</span>
                    </div>
                    <div className="show-details">
                      <h3>{show.venue}</h3>
                      <p className="location">{show.location}</p>
                      <p className="time">{show.time}</p>
                    </div>
                    <div className="show-actions">
                      <a href={show.ticketUrl} className="ticket-button">Get Tickets</a>
                      <a href={show.venueUrl} className="venue-link">Venue Info</a>
                    </div>
                  </div>
                  
                  {/* Right placeholder - only show if odd index */}
                  {!isEven && (
                    <div className={`show-placeholder right-placeholder ${show.venue === 'Ottobar' ? 'ottobar-placeholder' : ''} ${show.venue === 'The Pocket' ? 'pocket-placeholder' : ''} ${show.venue === 'Irisgarden Bar' ? 'irisgarden-placeholder' : ''}`}>
                      <img src={show.placeholderImage} alt={show.placeholderAlt} className="placeholder-image" />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </section>
    </main>
  );
}

export default Shows;